import { render, staticRenderFns } from "./AppointmentCell.vue?vue&type=template&id=132b5b47&"
import script from "./AppointmentCell.vue?vue&type=script&lang=js&"
export * from "./AppointmentCell.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentCell.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports